import {BasePathUrl} from "../appsettings";

/** Домашний маршрут SPA (HashRouter). */
export const getSpaHomeUrl = (): string =>
  new URL(`${BasePathUrl}/#/users`, globalThis.location.origin).toString();

/** Страница логина SPA — UX при impersonate без access к модулю Auth. */
export const getSpaLoginPath = (): string => `${BasePathUrl}/#/login`;

export const getSpaLoginUrl = (): string =>
  new URL(getSpaLoginPath(), globalThis.location.origin).toString();

/**
 * Browser navigation на Auth GET Impersonate:
 * cookie выставляется на origin Auth, затем 302 на redirectUrl.
 */
export const getImpersonateUrl = (impUserId: string, redirectUrl: string): string => {
  const url = new URL(`${BasePathUrl}/Account/Impersonate`, globalThis.location.origin);
  url.searchParams.set("impUserId", impUserId);
  url.searchParams.set("redirectUrl", redirectUrl);
  return url.toString();
};

/**
 * Нормализует redirect из ImpersonateResult для SPA под BasePathUrl.
 * Сервер может вернуть "/" — это корень домена, а не модуль.
 */
export const resolveImpersonateRedirect = (redirect?: string | null): string => {
  if (!redirect || redirect === "/") {
    const homeUrl = getSpaHomeUrl();
    // eslint-disable-next-line no-console
    console.debug("Redirect is empty or /, returning spa home url", homeUrl);
    return homeUrl;
  }

  if (redirect.startsWith("#")) {
    // eslint-disable-next-line no-console
    console.debug("Redirect starts with #, returning url", redirect);
    return new URL(`${BasePathUrl}/${redirect}`, globalThis.location.origin).toString();
  }

  // eslint-disable-next-line no-console
  console.debug("Redirect is not empty, returning url", redirect);
  return new URL(redirect, globalThis.location.origin).toString();
};

/** Относительный путь текущей страницы для redirectUrl (pathname + search + hash). */
export const getCurrentPageRedirectUrl = (): string => {
  const {pathname, search, hash} = globalThis.location;
  return `${pathname}${search}${hash}`;
};

export const getEndImpersonationUrl = (): string => {
  const url = new URL(`${BasePathUrl}/Account/Impersonate/Logout`, globalThis.location.origin);
  url.searchParams.set("redirectUrl", getCurrentPageRedirectUrl());
  return url.toString();
};

/** ReturnUrl из hash (#/login?ReturnUrl=...) или из window.location.search. */
export const parseReturnUrl = (): string | null => {
  const hashQuery = globalThis.location.hash.includes("?")
    ? globalThis.location.hash.slice(globalThis.location.hash.indexOf("?"))
    : "";
  const fromHash = new URLSearchParams(hashQuery).get("ReturnUrl");
  if (fromHash) {
    return fromHash;
  }

  return new URLSearchParams(globalThis.location.search).get("ReturnUrl");
};
